"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IMAGE_PARAMS = exports.FIFTY_LAYOUT_TITLE = exports.FIFTY_LAYOUT_TEXT = exports.FIFTY_LAYOUT_ROOT = exports.FIFTY_LAYOUT_NAME = exports.FIFTY_LAYOUT_MEDIA = exports.FIFTY_LAYOUT_CAPTION = void 0;
var _utils = require("../../utils");
const FIFTY_LAYOUT_NAME = exports.FIFTY_LAYOUT_NAME = 'EditorialFiftyBanner';
const FIFTY_LAYOUT_ROOT = exports.FIFTY_LAYOUT_ROOT = 'fifty-fifty';
const FIFTY_LAYOUT_TITLE = exports.FIFTY_LAYOUT_TITLE = 'fifty-title';
const FIFTY_LAYOUT_CAPTION = exports.FIFTY_LAYOUT_CAPTION = 'fifty-caption';
const FIFTY_LAYOUT_TEXT = exports.FIFTY_LAYOUT_TEXT = 'fifty-text';
const FIFTY_LAYOUT_MEDIA = exports.FIFTY_LAYOUT_MEDIA = 'fifty-media';
const IMAGE_PARAMS = exports.IMAGE_PARAMS = (0, _utils.getImageParamsAndSizes)({
    desktopWidth: 1366,
    mobileWidth: 600
});
